import { useState } from "react";

function SearchBar({ setComerciantes }) {
  const [nombre, setNombre] = useState("");
  const [tipoNegocio, setTipoNegocio] = useState("");
  const [localidad, setLocalidad] = useState("");
  
  const handleSearch = async () => {
    const params = new URLSearchParams();
    if (nombre.trim()) params.append("nombre", nombre.trim());
    if (tipoNegocio.trim()) params.append("tipoNegocio", tipoNegocio.trim());
    if (localidad.trim()) params.append("localidad", localidad.trim());
    if (patron.trim()) params.append("patron", patron.trim());

    if (params.toString()) {
      try {
        const response = await fetch(`https://panelcomerciantes.lagora.chat/api/searchComerciantes.php?${params.toString()}`);
        const data = await response.json();
        setComerciantes(data);
      } catch (error) {
        console.error("Error al buscar comerciantes:", error);
      }
    }
  };

  const [patron, setPatron] = useState("");

<input
  type="text"
  placeholder="Patrón..."
  value={patron}
  onChange={(e) => setPatron(e.target.value)}
/>

  return (
    <div>
      <input
        type="text"
        placeholder="Nombre..."
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
      />
      <input
        type="text"
        placeholder="Tipo de negocio..."
        value={tipoNegocio}
        onChange={(e) => setTipoNegocio(e.target.value)}
      />
      <input
        type="text"
        placeholder="Localidad..."
        value={localidad}
        onChange={(e) => setLocalidad(e.target.value)}
      />
      <input
        type="text"
        placeholder="Patron..."
        value={patron}
        onChange={(e) => setPatron(e.target.value)}
      />
      <button onClick={handleSearch}>Buscar</button>
    </div>
  );
}

export default SearchBar;
